import { createThemeContract } from "@vanilla-extract/css";

export const theme = createThemeContract({
  fonts: {
    primary: null,
    secondary: null,
  },
  colors: {
    background: null,
    backgroundTint: null,
    backgroundTintMarketing: null,
    backgroundShade: null,
    onBackground: null,

    defaultBorder: null,
    defaultBorderHover: null,
    softBorder: null,
    inputBorder: null,
    inputBorderFocus: null,
    inputPanel: null,
    placeholder: null,
    outline: null,
    panel: null,
    navigation: null,
    navigationTint: null,

    info: null,
    onInfo: null,
    infoHover: null,
    onInfoHover: null,
    infoSurface: null,
    onInfoSurface: null,

    success: null,
    onSuccess: null,
    successHover: null,
    onSuccessHover: null,
    successSurface: null,
    onSuccessSurface: null,

    warning: null,
    onWarning: null,
    warningHover: null,
    onWarningHover: null,
    warningSurface: null,
    onWarningSurface: null,

    error: null,
    onError: null,
    errorHover: null,
    onErrorHover: null,
    errorSurface: null,
    onErrorSurface: null,

    primary: null,
    onPrimary: null,
    primaryHover: null,
    onPrimaryHover: null,

    secondary: null,
    onSecondary: null,
    secondaryHover: null,
    onSecondaryHover: null,

    tertiary: null,
    onTertiary: null,
    tertiaryHover: null,
    onTertiaryHover: null,

    gradientA: null,
    gradientB: null,
    gradientC: null,
    gradientD: null,
    onGradient: null,
  },
  spacings: {
    xxs2: null,
    xxs: null,
    xs: null,
    s: null,
    s2: null,
    m: null,
    l: null,
    l2: null,
    xl: null,
    xxl: null,
    xxl2: null,
    xxl3: null,
    xxl4: null,
    xxl5: null,
  },
  borderRadiuses: {
    xxs2: null,
    xxs: null,
    xs: null,
    xs2: null,
    onXS: null,
    s: null,
    onS: null,
    m: null,
    l: null,
  },
  transition: {
    duration: {
      xs: null,
      s: null,
      m: null,
      l: null,
    },
    ease: null,
  },
});
